// Phase 2 — semantic spacing tokens
//
// Semantic spacing assigns named roles to values from bsky/tokens/space,
// so components reference a role ("component gap", "section margin") rather
// than a raw pixel value. Will be populated once bsky/tokens/space is
// complete in Figma (see FIGMA_DESIGN_SYSTEM_UPDATES.md, Part 2).
//
// Non-semantic spacing (direct t-shirt sizes) is already available via
// ALF atoms: atoms.gap_sm, atoms.p_md, etc.

export const spacing = {} as const

export type Spacing = typeof spacing
